<template>
    <div class="number-wrap">
        <div class="number-col-wrap">
        <span v-if="(error != '')" class="error">{{error}}</span>
        <input v-if="!fix" type="number" :min='min' :max='max' :step='step' :placeholder="placeholder ? placeholder : ''"  v-model.number="initialValues" @blur="setValue"/>
        <span class="fix" v-else>{{value}}</span>
        <div class="sepperator"></div>
        <label>{{label}}</label>
        <span v-if='required' class="required"> *</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return{
            values: this.initialValues,
            error:""
        }
	},
    props:{
        fix:Boolean,
        fieldId:String,
        formId:String,
        taskId:Number,
        parentId:Number,
        required:Boolean,
        value:Number,
        label:String,
        placeholder:String,
        min:Number,
        max:Number,
        step:Number,
        isPersonal:Boolean
    },
    computed:{
        initialValues:{
            get () {
                let vals = ''
                if(this.form){
                    if(this.form.fields[this.fieldId]){
                        vals =  this.form.fields[this.fieldId].value;
                    }
                }
                return vals;
            },
            set(val){
                if(typeof val == 'number')
                {
                    this.values = val;
                }else{
                    console.log("not a number!");
                }
            }
        },
        form: function(){
            return this.getCheckResultByFormId(this.formId, this.taskId, this.isPersonal);
        },
        ...mapGetters([
            'getCheckResultByFormId',
        ])
    },
    methods:{
        setValue(){
            if(isNaN(this.values) || this.values < this.min || this.values > this.max){
                this.error = "please enter a number between "+this.min+" and "+this.max;
            }else{
                this.$store.commit("setFieldResult",{'formId':this.formId, 'taskId':this.taskId,'fieldId':this.fieldId,'value':this.values, 'parentId':this.parentId, type:'number', 'isPersonal':this.isPersonal})
                this.error = "";
            }
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/scss/styles.scss";
.number-wrap{
    width: 100%;
    margin: 10px auto;
    border-radius: 3px;
    background-color: $bgColorLightLight;
    padding:8px 3px;
    display:flex;
    flex-wrap: wrap;
    input{
        width: 90%;
        height:35px;
        font-size: 3rem;
        background: transparent;
        border: none;
        padding:5px;
        font-size: 1.2rem;
        resize:none;
        outline: none;
    }
    .number-col-wrap{
        flex: 1 1 50%;
    }
    .sepperator{
        border-bottom:1px solid rgba(0,0,0,.1);
        width: 80%;
        margin:auto;
    }
    .fix{
        padding:5px;
    }
    label{
        padding:5px;
        font-size: .7rem;
        font-weight: bold;
        color: $fontColorMedLight;
    }
    .error{
        color:$trafficLightColorRed;
    }
}
</style>